import React from 'react';
import PropTypes from 'prop-types';
import {saveAs} from 'file-saver';

//MUI Components
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import {LoadingButton} from '@mui/lab';
import DownloadIcon from '@mui/icons-material/Download';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import {Grid} from '@mui/material';

import {StyledReportWrapper} from 'components/styled';

import {useLazyGetReportQuery} from 'api';
import {FORBIDDEN_ERROR_STATUS_CODE} from 'constants';

//REDUX
import {connect} from 'react-redux';
import {rightsSelector} from 'redux/slices/appSlice';

const ReportCard = ({report, rights}) => {
  const [getReport, {isFetching: isDownloading, isError: isReportError, error: reportError}] = useLazyGetReportQuery();

  const downloadReport = () => {
    getReport(report.id).then((resultReport) => {
      if (resultReport.data && !resultReport.isError) {
        const blob = new Blob([resultReport.data], {
          type: 'text.csv'
        });
        saveAs(blob, `${report.id}.csv`);
      }
    });
  };

  return (
    <Grid container justifyContent="center" style={{padding: 24}}>
      <StyledReportWrapper sx={{minWidth: 275, maxWidth: 1000}}>
        {isReportError &&
          (reportError.status === FORBIDDEN_ERROR_STATUS_CODE ? (
            <Alert style={{marginTop: 0, marginBottom: 24}} severity="error">
              You are not allowed to download reports. Please contact an administrator.
            </Alert>
          ) : (
            <Alert style={{marginTop: 0, marginBottom: 24}} severity="error">
              Sorry, there are problems with downloading report. Please try again.
            </Alert>
          ))}

        <CardContent>
          <Typography variant="h5" component="div" sx={{marginBottom: 1}}>
            {report.title}
          </Typography>
          <Typography variant="body2">{report.description}</Typography>
        </CardContent>

        <CardActions>
          <LoadingButton
            sx={{marginLeft: 'auto'}}
            onClick={() => downloadReport()}
            disabled={!rights.reports}
            loading={isDownloading}
            endIcon={<DownloadIcon />}
            loadingPosition="end"
          >
            Download
          </LoadingButton>
        </CardActions>
      </StyledReportWrapper>
    </Grid>
  );
};

ReportCard.propTypes = {
  report: PropTypes.object,
  rights: PropTypes.object
};

const mapStateToProps = (state) => ({
  rights: rightsSelector(state)
});

export default connect(mapStateToProps)(ReportCard);
